var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hints.trim() !== '')?_c('div',{staticClass:"comp-hint comp border-top"},[_c('div',{staticClass:"hint"},[_vm._m(0),_c('div',{staticClass:"hint-list",domProps:{"innerHTML":_vm._s(_vm.hints)}})])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-warning",attrs:{"aria-hidden":"true"}}),_vm._v("\n            温馨提示：\n        ")])
}]

export { render, staticRenderFns }